import * as getData from '../service/getData'
import * as types from './mutation-types.js'

import store from '../story/'



export default {


}



// WEBPACK FOOTER //
// ./src/story/action.js